import React from 'react'
import { FormattedDate, FormattedMessage } from 'react-intl'
import { Tag } from 'primereact/tag'
import { Badge } from 'primereact/badge'
import ProgressBarComp from '../../progress-bar/ProgressBarCom'
import InputMaskComp from '../../form-components/inputs/InputMaskComp'
import InputNumberComp from '../../form-components/inputs/InputNumberComp'
import { propsInputNumberCurrency } from '../../../../utils/constants/common'
import CheckboxCom from '../../form-components/checkbox/CheckboxComp'
import { formatCurrency } from '../../../../utils/helpers/common'

const BodyRenderItems = ({ items }) => {
  return items && items.length > 0 ? (
    <div className="items-column">
      {items.map((item) =>
        !Array.isArray(item) ? (
          <span key={Math.random()} className="item">
            {typeof item === 'string'
              ? item
              : item?.name || item?.subaccount || item?.label || item?.account}
          </span>
        ) : (
          'null'
        ),
      )}
    </div>
  ) : (
    <span className="sense-items" />
  )
}

export const bodyPhoneInputMask = (data) => (
  <InputMaskComp
    disabled
    mask="999 999 999"
    style={{ minWidth: 100, width: 100 }}
    value={data}
  />
)

export const bodyCurrencyInput = (data, propsInput) => (
  <InputNumberComp
    disabled
    value={data}
    {...propsInputNumberCurrency}
    {...propsInput}
  />
)

export const bodyCheckbox = (data) => <CheckboxCom disabled checked={data} />

export const bodyProgressBar = (value) => <ProgressBarComp value={value} />

export const bodyRenderTypes = (items) => <BodyRenderItems items={items} />

export const bodyStatusTag = (data) => {
  const getSeverity = data ? 'danger' : 'success'
  const valueText = data ? (
    <FormattedMessage id="cancelled" />
  ) : (
    <FormattedMessage id="ok" />
  )
  return <Tag value={valueText} severity={getSeverity} />
}

export const bodyBadge = ({ data, textSufix }) => (
  <Badge value={`${data} ${textSufix || ''}`} />
)

export const bodyParseDate = ({ date, dateTimeFormat = false }) => {
  const formatDate = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  }
  const formatDataAndHour = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  }

  const format = dateTimeFormat ? formatDataAndHour : formatDate

  return date && <FormattedDate value={date} {...format} />
}
